import {
  IEmployeeManagementData,
  IEmployeeCreator,
  IEmployeeTypes,
  IEmployeeManagementState,
} from "models/IEmployeeState";

const employeeInitialState: IEmployeeManagementState = {
  data: {
    current_page: 0,
    data: [],
    designations_list: [],
    employees_list: [],
    error: "",
    limit: 0,
    message: "",
    status: "",
    teams_list: [],
    total_items: 0,
    total_pages: 0,
  },
};

const reducer = (
  state = employeeInitialState,
  { type, payload }: IEmployeeCreator
) => {
  switch (type) {
    case IEmployeeTypes.EMPLOYEE_LIST_FAILURE:
      return {
        ...state,
        employeeInitialState,
      };
    case IEmployeeTypes.EMPLOYEE_LIST_SUCCESS:
      return {
        ...state,
        data: payload,
      };
    default:
      return state;
  }
};

export default reducer;
